import { Clonable, getTeamFirebaseStoragePath, TeamPublicCacheSettings } from '../../..';

export class TeamPublicCache extends Clonable {
  constructor(
    public readonly id: string,
    public readonly updatedAt: Date,
    public readonly name: string,
    public readonly settings: TeamPublicCacheSettings,
  ) {
    super();
  }

  /** Returns Firebase Storage path for the public album logo */
  public getTeamLogoPath(): string {
    return getTeamFirebaseStoragePath(this.id, this.settings['team.logo'] ?? '');
  }

  public hasTeamLogo(): boolean {
    return !!this.settings['team.logo'];
  }
}
